import { bootstrapApplication } from '@angular/platform-browser';
import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Configure DevExtreme license
config({ licenseKey });

bootstrapApplication(AppComponent, appConfig)
